import React from 'react';
import { Button } from '@ui-propulsion/react-components';

const FillMe = (props) => {
  const { handleOnClick, env } = props;
  const disabled = env === 'prod';

  if (!disabled) {
    return <div id='fill-form-wrap' className='fill-form-wrap'>
            <Button
              className='fill-form-button'
              onClick={handleOnClick}
            >Fill Form</Button>
          </div>;
  }
  return null;
};

FillMe.defaultProps = {
  handleOnClick: null,
  env: 'prod'
};

export default FillMe;

